import { Stack, Text, ThemeIcon } from '@mantine/core'
import type { ReactNode } from 'react'
import { IconInbox } from '@/components/icons'

type Props = {
  title: string
  description?: string
  icon?: ReactNode
  /** Кнопка или ссылка под текстом */
  action?: ReactNode
}

/** Пустой список / нет данных */
export function EmptyState({
  title,
  description,
  icon,
  action,
}: Props) {
  return (
    <Stack align="center" gap="md" py="xl" px="md">
      <ThemeIcon size={52} radius="md" variant="light" color="gray">
        {icon ?? <IconInbox size={28} stroke={1.5} />}
      </ThemeIcon>
      <Stack align="center" gap={4} maw={360}>
        <Text fw={600} ta="center">
          {title}
        </Text>
        {description ? (
          <Text size="sm" c="dimmed" ta="center">
            {description}
          </Text>
        ) : null}
      </Stack>
      {action}
    </Stack>
  )
}
